var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"program-element",class:{'mobile': _vm.isMobile, 'xl-screen': _vm.isExtraLargeScreen, 'gradient': _vm.gradient},style:(_vm.styles)},[(_vm.isMultiSession)?_c('agenda'):_c('program-single-session')],1)}
var staticRenderFns = []

export { render, staticRenderFns }